import axios from 'axios';

// Set your base URL (as per your configuration)
axios.defaults.baseURL = "https://dev.cloudregis.com/checking/laravel/public/";
axios.defaults.headers.post['Content-Type'] = "application/json";
axios.defaults.headers.post['Accept'] = "application/json";
axios.defaults.withCredentials = true;

// Request interceptor for authentication
axios.interceptors.request.use(function (config) {
  const token = localStorage.getItem('auth_token');
  config.headers.Authorization = token ? `Bearer ${token}` : '';
  return config;
});

// Response interceptor for handling errors
axios.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      // Redirect to login if unauthorized
      localStorage.removeItem('auth_token');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

export const whatsappApi = {
  // Send message
  sendMessage: async (phone, message) => {
    try {
      const response = await axios.post('/api/whatsapp/send-message', {
        phone,
        message
      });
      return response.data;
    } catch (error) {
      throw error.response?.data || { error: error.message };
    }
  },

  // Send file
  sendFile: async (phone, fileUrl, fileName) => {
    try {
      const response = await axios.post('/api/whatsapp/send-file', {
        phone,
        file_url: fileUrl,
        file_name: fileName
      });
      return response.data;
    } catch (error) {
      throw error.response?.data || { error: error.message };
    }
  },

  // Get account state
  getAccountState: async () => {
    try {
      const response = await axios.get('/api/whatsapp/account-state');
      return response.data;
    } catch (error) {
      throw error.response?.data || { error: error.message };
    }
  },

  // Test connection
  testConnection: async () => {
    try {
      const response = await axios.get('/api/whatsapp/test-connection');
      return response.data;
    } catch (error) {
      throw error.response?.data || { error: error.message };
    }
  }
};

export default axios;